/* eslint-disable unicorn/filename-case -- legacy Upload*.tsx naming */
import CloseIcon from "@mui/icons-material/Close";

import { CompressedImage } from "@/components/common/CompressedImage";
import PdfPreview from "../pdfPreview";
import type { UploadPreviewProps } from "./types";
import {
  HeaderBox,
  ImageContainer,
  StyledDialog,
  StyledDialogContent,
  StyledIconButton,
  StyledTypography,
} from "./UploadStyles/UploadPreviewStyles";

export function UploadPreview({ open, onClose, document, isImage }: UploadPreviewProps) {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="md">
      <StyledDialogContent>
        {/* Header with close button and title */}
        <HeaderBox>
          <StyledTypography variant="subtitle1">
            {document?.label ?? document?.name ?? "Document Preview"}
          </StyledTypography>
          <StyledIconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </StyledIconButton>
        </HeaderBox>

        {/* Image Container */}
        <ImageContainer>
          {isImage ? (
            <CompressedImage
              image={{ url: document?.url ?? "" }}
              alt={document?.label ?? document?.name ?? "Document"}
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <PdfPreview url={document.url} />
          )}
        </ImageContainer>
      </StyledDialogContent>
    </StyledDialog>
  );
}
